import api from './index';
import { appendQueryParamsToUrl } from '../utils';
import { Worktype, WorktypeForm, WorktypeEditForm } from '../types/Worktype.interface';
import { AxiosResponse } from 'axios';

const BASE = '/worktype';

export const getWorktypes = async ({ location }: { location?: number }) => {
    let url = `${BASE}`;
    url = appendQueryParamsToUrl(url, { location });

    return api.get(url).then((res) => res.data);
};

export const getAllWorktype = async () => {
    return api.get(`${BASE}`).then((res) => res.data);
};

export const getAllWorktypeByLocation = async (location: number) => {
    return api.get(`${BASE}/getAllWorktypeByLocation?location=${location}`).then((res) => res.data);
};

export const createWorktype = async ({ worktype, forecasters, shortName, customerSegments }: WorktypeForm) => {
    return api
        .post<Worktype, AxiosResponse<Worktype>, WorktypeForm>(`${BASE}`, { worktype, forecasters, shortName, customerSegments })
        .then((res) => res.data);
};

export const deleteWorktype = async (id: number, deleteRelatedData: boolean) =>
    await api.delete(`${BASE}/${id}?deleteRelatedData=${deleteRelatedData}`);

export const updateWorktype = async ({ id, worktype, forecasters, shortName, customerSegments }: WorktypeEditForm) => {
    return api
        .patch<Worktype, AxiosResponse<Worktype>, WorktypeForm>(`${BASE}/${id}`, { worktype, forecasters, shortName, customerSegments })
        .then((res) => res.data);
};
